import { apiClient } from './ApiService';

/**
 * Custom mutator for Orval that uses our existing ApiService
 * This ensures all generated API calls go through our authentication system
 * and properly handles 204 No Content responses
 */
export const apiMutator = async <T>(url: string, options: RequestInit = {}): Promise<T> => {
  const method = options.method || 'GET';
  const body = options.body ? JSON.parse(options.body as string) : undefined;
  const headers = (options.headers as Record<string, string>) || {};
  const cleanUrl = url.replace('/api', '');

  const publicEndpoints = [
    '/account/signup',
    '/account/login',
    '/account/request-reset-password',
    '/account/reset-password'
  ];
  const authRequired = !publicEndpoints.some((endpoint) => cleanUrl.includes(endpoint));

  let data: any;

  switch (method.toLowerCase()) {
    case 'get':
      data = await apiClient.get(cleanUrl, headers, authRequired);
      break;
    case 'post':
      data = await apiClient.post(cleanUrl, body, headers, authRequired);
      break;
    case 'put':
      data = await apiClient.put(cleanUrl, body, headers, authRequired);
      break;
    case 'patch':
      data = await apiClient.patch(cleanUrl, body, headers, authRequired);
      break;
    case 'delete':
      data = await apiClient.delete(cleanUrl, body, headers, authRequired);
      break;
    default:
      throw new Error(`Unsupported HTTP method: ${method}`);
  }

  if (data && typeof data === 'object' && data.status === 204) {
    return {
      data: null,
      status: 204,
      headers: new Headers()
    } as T;
  }

  return {
    data,
    status: data.status,
    headers: new Headers()
  } as T;
};

export default apiMutator;
